"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.genAxiosClient = void 0;
var _axios = _interopRequireWildcard(require("axios"));
var _axiosRetry = _interopRequireDefault(require("axios-retry"));
var _constants = require("./constants");
// override axios type so we have hooks into the config

var defaultRetryConfig = {
  retries: _constants.DEFAULT_MAX_ATTEMPTS,
  retryDelay: function retryDelay(numAttempts) {
    return numAttempts * _constants.RETRY_DELAY_MS;
  }
};

/**
 * Generate an axios HTTP client to make requests with. By default, it will come with the following
 * features turned on:
 * - Retry logic
 *
 * These features can be reconfigured by adding a config to replace them, and they can be turned off
 * by sumbitting `false` in place of a config.
 * @param config Configuration object containing settings for retry.
 * @returns A pre-configured axios instance
 */
var genAxiosClient = function genAxiosClient() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$retryConfig = config.retryConfig,
    retryConfig = _config$retryConfig === void 0 ? defaultRetryConfig : _config$retryConfig;
  var axiosOptions = {
    smartsheet: {
      retryEnabled: retryConfig !== false,
      retryConfig: retryConfig !== false ? retryConfig : undefined
    }
  };
  var client = _axios.default.create(axiosOptions);
  if (retryConfig !== false) {
    (0, _axiosRetry.default)(client, retryConfig);
  }
  return client;
};
exports.genAxiosClient = genAxiosClient;
//# sourceMappingURL=client.js.map